import { render, staticRenderFns } from "./propertyService.vue?vue&type=template&id=8a0e2fb8&scoped=true"
import script from "./propertyService.vue?vue&type=script&lang=js"
export * from "./propertyService.vue?vue&type=script&lang=js"
import style0 from "./propertyService.vue?vue&type=style&index=0&id=8a0e2fb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0e2fb8",
  null
  
)

export default component.exports